import { MessageCircle } from "lucide-react";
import { usePageContent } from "../lib/pageContent";

const DEFAULT_PHONE = "971500000000";

export const WhatsAppButton = () => {
  const c = usePageContent();
  const raw = (c?.whatsapp_number || DEFAULT_PHONE).toString();
  const phone = raw.replace(/[^0-9]/g, "") || DEFAULT_PHONE;
  return (
    <a
      href={`https://wa.me/${phone}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white rounded-full px-5 py-3 shadow-hover transition-all active:scale-95"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle size={20} />
      <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
    </a>
  );
};
